import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';

import {
  ProductIcon,
  ProductDentalIcon,
  ProductVisionIcon,
} from '../EnrollmentIconsSvg';
import './styles/compare-plan-result.scss';

const ComparePlanResultPage = ({
  setShowComparePlans,
  compareProductsPlans,
  compareProductTabName,
}) => (
  <div className="compare-plan-container">
    <Container>
      <div>
        <Row>
          <Col md={12} className="compare-result-panel">
            <div className="compare-result-container">
              <div className="compare-title">
                Compare <span className="boldText">Products</span>
              </div>
              <div className="compare-result-height">
                <table className="compare-result-container-pane">
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header-title">
                        <div className="column-header-icon">
                          {compareProductTabName === 'medical' && (
                            <ProductIcon
                              classNameSecondary="card-view--icon-secondary"
                              classNamePrimary="card-view-icon"
                            />
                          )}
                          {compareProductTabName === 'dental' && (
                            <ProductDentalIcon
                              classNameSecondary="card-view--icon-secondary"
                              classNamePrimary="card-view-icon"
                            />
                          )}
                          {compareProductTabName === 'vision' && (
                            <ProductVisionIcon
                              classNameSecondary="card-view--icon-secondary"
                              classNamePrimary="card-view-icon"
                            />
                          )}
                        </div>
                        <span>Plans with Premiums</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-title">
                            <div className="column-title-icon">
                              {compareProductTabName === 'medical' && (
                                <ProductIcon
                                  classNameSecondary="card-view--icon-secondary"
                                  classNamePrimary="card-view-icon"
                                />
                              )}
                              {compareProductTabName === 'dental' && (
                                <ProductDentalIcon
                                  classNameSecondary="card-view--icon-secondary"
                                  classNamePrimary="card-view-icon"
                                />
                              )}
                              {compareProductTabName === 'vision' && (
                                <ProductVisionIcon
                                  classNameSecondary="card-view--icon-secondary"
                                  classNamePrimary="card-view-icon"
                                />
                              )}
                            </div>
                            <span>{p.planTitle}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Tier Rating</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.tierRating}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Star Rating</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.starRating}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Copay</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.copay}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Coinsurance</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.coinsurance}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Patients Responsibility</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.patientResponsibility}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td colSpan={4} className="column-section-header">
                      In-network
                    </td>
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Deductible</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.inNetworkDeductible}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Out-of-pocket</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.inNetworkOutOfPocket}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td colSpan={4} className="column-section-header">
                      Out-of-network
                    </td>
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Deductible</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.outOfNetworkDeductible}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Out-of-pocket</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>{p.outOfNetworkOutOfPocket}</span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr>
                    <td colSpan={4} className="column-section-header">
                      &nbsp;
                    </td>
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Primary Care Provider</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span
                              className={
                                p.primaryCareProvider === 'Required'
                                  ? 'required-text'
                                  : 'not-required-text'
                              }
                            >
                              {p.primaryCareProvider}
                            </span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Networks</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>
                              {p.networks &&
                                p.networks.length > 0 &&
                                p.networks.map((network, index) => (
                                  <div key={index}>{network}</div>
                                ))}
                            </span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Generic Drugs</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <span>
                              {p.genricDrugs &&
                                p.genricDrugs.length > 0 &&
                                p.genricDrugs.map((drug, index) => (
                                  <div key={index}>{drug}</div>
                                ))}
                            </span>
                          </div>
                        </td>
                      ))}
                  </tr>
                  <tr className="compare-result-pane-row">
                    <td className="compare-result-pane">
                      <div className="column-header">
                        <span>Benefits</span>
                      </div>
                    </td>
                    {compareProductsPlans &&
                      compareProductsPlans.map((p) => (
                        <td key={p.planId} className="compare-result-pane">
                          <div className="column-value">
                            <ul>
                              {p.benefits &&
                                p.benefits.length > 0 &&
                                p.benefits.map((benefit, index) => (
                                  <li key={index}>{benefit}</li>
                                ))}
                            </ul>
                          </div>
                        </td>
                      ))}
                  </tr>
                </table>
              </div>
              <div className="d-flex justify-content-end">
                <GenericButton
                  type="button"
                  className="mr-0"
                  onClick={() => {
                    setShowComparePlans(false);
                  }}
                >
                  Close
                </GenericButton>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  </div>
);
export default ComparePlanResultPage;
